import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const Bookmark = (props: SvgProps) => (
  <Svg viewBox='0 0 11 13' {...props}>
    <Path
      d='M10 12 5.5 8.944 1 12V2.222c0-.324.135-.635.377-.864A1.32 1.32 0 0 1 2.286 1h6.428c.341 0 .668.129.91.358.24.23.376.54.376.864V12Z'
      fill='currentColor'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
